<template>
    <div v-bind:class="className">
        <label class="control-label"> {{item.label}} </label>
        <input v-bind:type="item.type" class="form-control margin-bottom" v-bind:value="item.value" v-on:input="update" v-bind:placeholder="item.placeholder" v-bind:name="item.name" v-bind:maxlength="item.maxlength" v-bind:readonly="item.readonly" v-bind:max="item.max" v-bind:min="item.min">
        <div v-for="error in item.errors"  id="errors">
            {{ error }}
        </div>
    </div>
</template>

<script>
export default{
    name: 'emt-input',
    props: {
        item: Object,
        className: String
    },
    methods: {
        update: function (event) {
            var self = this
            self.item.value = event.target.value
            this.$emit('input', event.target.value)
        }
    }
}
</script>



// WEBPACK FOOTER //
// emt-input.vue?651f8550